import { render, staticRenderFns } from "./SelectAnchors.vue?vue&type=template&id=3c20d0b9&scoped=true&"
import script from "./SelectAnchors.vue?vue&type=script&lang=js&"
export * from "./SelectAnchors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20d0b9",
  null
  
)

export default component.exports